import Paragraph from './Paragraph.vue'

export default Paragraph
